<script setup lang="ts">
/**
 * The signature under the editor while a mail is written (#1115): what the OS will add after the body, shown as its
 * plain text, with a box to leave it off this one mail. That is the mailbox's own signature, or the enterprise's
 * template filled in for the mailbox when it has none of its own (#1118). Nothing when no signature will be added.
 */
import { Checkbox } from '@zerohuman/ui'
import { computed } from 'vue'
import type { MailSignature } from '@/api'
import { signatureInUse } from '@/lib/mailSignature'

const props = defineProps<{ signature: MailSignature | null; disabled?: boolean; testid?: string }>()
/** Whether the signature goes with this mail. */
const add = defineModel<boolean>({ required: true })

const inUse = computed(() => signatureInUse(props.signature))
</script>

<template>
	<div v-if="inUse" class="space-y-1 text-sm" :data-testid="testid">
		<label class="flex items-center gap-2">
			<Checkbox :model-value="add" :disabled="disabled" data-signature-toggle @update:model-value="add = $event === true" />
			{{ inUse.fromTemplate ? 'Add the enterprise signature' : 'Add signature' }}
		</label>
		<pre v-if="add" class="text-muted-foreground border-border border-l-2 pl-3 font-sans text-xs whitespace-pre-wrap" data-signature-preview>{{ inUse.text }}</pre>
	</div>
</template>
